export const environment = {
  production: true,
  publicConfigUrl: '/api/public/configuration',
  localDevSsoRedirect: false,
  ssoLoginRedirectIntervalInHours: 24,

  sentryDisabledOnUrls: new RegExp('^(?!.*(?:rpqa20-gi.rampitplatform.com|rpqa20-postman.rampitplatform.com|localhost)).*$'),
  // sentry config
  sentry: {
    DSN: 'https://2aef790c05277a05781d6779b9261c89@o4504165036457984.ingest.us.sentry.io/4509331328794624',
    // environment setting needs to be updated as per the environment this is deployed to
    environment: 'prod',
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  sentryIgnoredErrors: ['auth/wrong-password', 'auth/invalid-email', 'auth/user-not-found'],
};
